import en from './langs/en'
import fr from './langs/fr'

export let locales = [
    {
        value: 'en',
        name: 'English',
        native: 'English'
    },
    {
        value: 'fr',
        name: 'French',
        native: 'Francais'
    }
]

export default {
    en, fr
}
